<!-- eslint-disable vue/no-v-html -->
<template>
  <section class="result-content-height">
    <div
      class="relative w-full overflow-hidden bg-cover bg-center bg-no-repeat after:absolute after:left-0 after:top-0 after:block after:h-full after:w-full after:bg-gradient-to-r after:from-white after:to-white/0 after:content-['']"
      :style="bannerStyle"
    >
      <div class="container-wrap relative z-10 h-form-banner py-2">
        <div class="flex h-full w-full flex-col justify-center">
          <h1 class="text-h1 mb-3 line-clamp-2 tablet:mb-6">
            {{ t('title') }}
          </h1>
          <p class="text-sm tablet:text-base">
            {{ t('intro', { solutionName: solutionData?.banner?.title }) }}
          </p>
          <p class="mt-6 text-sm tablet:text-base">
            {{ t('list-title', { solutionName: solutionData?.banner?.title }) }}
          </p>
          <ul class="mb-6 ml-6 list-disc text-sm tablet:text-base">
            <li>{{ t('list-1') }}</li>
            <li>{{ t('list-2') }}</li>
            <li>{{ t('list-3') }}</li>
          </ul>
          <p class="text-sm tablet:text-base">{{ t('closing-1') }}</p>
          <p
            class="mt-6 text-sm tablet:text-base"
            v-html="decode(t('closing-2'))"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { decode } from 'entities';

  const { t } = useI18n({ useScope: 'local' });
  const { blobDomain } = useWebsite();

  const solutionsStore = useSolutionsStore();
  const { solutionData } = storeToRefs(solutionsStore);

  const bannerStyle = computed(
    (): string =>
      `background-image: url(${blobDomain.value}/wise-paas-marketplace/solutions/form_banner.jpg)`
  );
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "Almost there! Check your email.",
    "intro": "Your demo request for {solutionName} has been received. Our team will reach out soon to schedule your session.",
    "list-title": "Get ready to explore how {solutionName} can help your business:",
    "list-1": "See a live demo tailored to your needs.",
    "list-2": "Discover key features and real-world use cases.",
    "list-3": "Get expert insights and answers to your questions.",
    "closing-1": "Check your inbox for a confirmation email. If you don't see it soon, check your spam folder.",
    "closing-2": "Need assistance? Contact our support team at <a href=\"mailto:WISE-Marketplace&#64;advantech.com\" title=\"WISE-Marketplace&#64;advantech.com\" class=\"text-blue-400 font-bold hover:underline\">WISE-Marketplace&#64;advantech.com</a>"
  },
  "en-jp": {
    "title": "Almost there! Check your email.",
    "intro": "Your demo request for {solutionName} has been received. Our team will reach out soon to schedule your session.",
    "list-title": "Get ready to explore how {solutionName} can help your business:",
    "list-1": "See a live demo tailored to your needs.",
    "list-2": "Discover key features and real-world use cases.",
    "list-3": "Get expert insights and answers to your questions.",
    "closing-1": "Check your inbox for a confirmation email. If you don't see it soon, check your spam folder.",
    "closing-2": "Need assistance? Contact our support team at <a href=\"mailto:WISE-Marketplace&#64;advantech.com\" title=\"WISE-Marketplace&#64;advantech.com\" class=\"text-blue-400 font-bold hover:underline\">WISE-Marketplace&#64;advantech.com</a>"
  },
  "en-tw": {
    "title": "Almost there! Check your email.",
    "intro": "Your demo request for {solutionName} has been received. Our team will reach out soon to schedule your session.",
    "list-title": "Get ready to explore how {solutionName} can help your business:",
    "list-1": "See a live demo tailored to your needs.",
    "list-2": "Discover key features and real-world use cases.",
    "list-3": "Get expert insights and answers to your questions.",
    "closing-1": "Check your inbox for a confirmation email. If you don't see it soon, check your spam folder.",
    "closing-2": "Need assistance? Contact our support team at <a href=\"mailto:WISE-Marketplace&#64;advantech.com\" title=\"WISE-Marketplace&#64;advantech.com\" class=\"text-blue-400 font-bold hover:underline\">WISE-Marketplace&#64;advantech.com</a>"
  },
  "en-kr": {
    "title": "Almost there! Check your email.",
    "intro": "Your demo request for {solutionName} has been received. Our team will reach out soon to schedule your session.",
    "list-title": "Get ready to explore how {solutionName} can help your business:",
    "list-1": "See a live demo tailored to your needs.",
    "list-2": "Discover key features and real-world use cases.",
    "list-3": "Get expert insights and answers to your questions.",
    "closing-1": "Check your inbox for a confirmation email. If you don't see it soon, check your spam folder.",
    "closing-2": "Need assistance? Contact our support team at <a href=\"mailto:WISE-Marketplace&#64;advantech.com\" title=\"WISE-Marketplace&#64;advantech.com\" class=\"text-blue-400 font-bold hover:underline\">WISE-Marketplace&#64;advantech.com</a>"
  },
  "en-americas": {
    "title": "Almost there! Check your email.",
    "intro": "Your demo request for {solutionName} has been received. Our team will reach out soon to schedule your session.",
    "list-title": "Get ready to explore how {solutionName} can help your business:",
    "list-1": "See a live demo tailored to your needs.",
    "list-2": "Discover key features and real-world use cases.",
    "list-3": "Get expert insights and answers to your questions.",
    "closing-1": "Check your inbox for a confirmation email. If you don't see it soon, check your spam folder.",
    "closing-2": "Need assistance? Contact our support team at <a href=\"mailto:WISE-Marketplace&#64;advantech.com\" title=\"WISE-Marketplace&#64;advantech.com\" class=\"text-blue-400 font-bold hover:underline\">WISE-Marketplace&#64;advantech.com</a>"
  },
  "en-asia-pacific": {
    "title": "Almost there! Check your email.",
    "intro": "Your demo request for {solutionName} has been received. Our team will reach out soon to schedule your session.",
    "list-title": "Get ready to explore how {solutionName} can help your business:",
    "list-1": "See a live demo tailored to your needs.",
    "list-2": "Discover key features and real-world use cases.",
    "list-3": "Get expert insights and answers to your questions.",
    "closing-1": "Check your inbox for a confirmation email. If you don't see it soon, check your spam folder.",
    "closing-2": "Need assistance? Contact our support team at <a href=\"mailto:WISE-Marketplace&#64;advantech.com\" title=\"WISE-Marketplace&#64;advantech.com\" class=\"text-blue-400 font-bold hover:underline\">WISE-Marketplace&#64;advantech.com</a>"
  },
  "en-emea": {
    "title": "Almost there! Check your email.",
    "intro": "Your demo request for {solutionName} has been received. Our team will reach out soon to schedule your session.",
    "list-title": "Get ready to explore how {solutionName} can help your business:",
    "list-1": "See a live demo tailored to your needs.",
    "list-2": "Discover key features and real-world use cases.",
    "list-3": "Get expert insights and answers to your questions.",
    "closing-1": "Check your inbox for a confirmation email. If you don't see it soon, check your spam folder.",
    "closing-2": "Need assistance? Contact our support team at <a href=\"mailto:WISE-Marketplace&#64;advantech.com\" title=\"WISE-Marketplace&#64;advantech.com\" class=\"text-blue-400 font-bold hover:underline\">WISE-Marketplace&#64;advantech.com</a>"
  },
  "ja-jp": {
    "title": "まもなく完了です！メールをご確認ください。",
    "intro": "{solutionName} のデモリクエストを受け付けました。弊社チームより、セッションの日程調整についてご連絡いたします。",
    "list-title": "{solutionName} が貴社ビジネスにもたらす可能性をご体験ください：",
    "list-1": "ニーズに合わせたライブデモ",
    "list-2": "主な機能と実際の導入事例のご紹介",
    "list-3": "専門家によるご提案と質疑応答",
    "closing-1": "確認メールをご確認ください。メールが届かない場合は、迷惑メールフォルダもご確認ください。",
    "closing-2": "ご不明な点がございましたら、<a href=\"mailto:WISE-Marketplace&#64;advantech.com\" title=\"WISE-Marketplace&#64;advantech.com\" class=\"text-blue-400 font-bold hover:underline\">WISE-Marketplace&#64;advantech.com</a> までお問い合わせください。"
  },
  "zh-cn": {
    "title": "马上就完成了！请查收您的邮箱。",
    "intro": "我们已收到您提交的 {solutionName} 演示申请。我们的团队将尽快与您联系，安排演示时间。",
    "list-title": "准备好了解 {solutionName} 如何为您的业务赋能：",
    "list-1": "针对需求定制的在线演示",
    "list-2": "关键功能与真实应用场景展示",
    "list-3": "专家讲解与专业答疑",
    "closing-1": "请查看您的收件箱确认邮件，如未收到，请检查垃圾邮件文件夹。",
    "closing-2": "如需帮助，请联系支持团队：<a href=\"mailto:WISE-Marketplace&#64;advantech.com\" title=\"WISE-Marketplace&#64;advantech.com\" class=\"text-blue-400 font-bold hover:underline\">WISE-Marketplace&#64;advantech.com</a>"
  },
  "zh-tw": {
    "title": "快完成囉！請查看您的信箱。",
    "intro": "我們已收到您對 {solutionName} 的展示申請，團隊將盡快與您聯繫安排展示時程。",
    "list-title": "準備好探索 {solutionName} 為您的企業帶來哪些效益：",
    "list-1": "客製化的即時產品展示",
    "list-2": "關鍵功能與實際應用案例介紹",
    "list-3": "專家解說與問題解答",
    "closing-1": "請至您的電子信箱查收確認信件；若未收到，請檢查垃圾郵件匣。",
    "closing-2": "若您需要協助，歡迎聯繫我們的支援團隊：<a href=\"mailto:WISE-Marketplace&#64;advantech.com\" title=\"WISE-Marketplace&#64;advantech.com\" class=\"text-blue-400 font-bold hover:underline\">WISE-Marketplace&#64;advantech.com</a>"
  }
}
</i18n>
